import { render, staticRenderFns } from "./goodTimeoutList.vue?vue&type=template&id=481039ea"
import script from "./goodTimeoutList.vue?vue&type=script&lang=js"
export * from "./goodTimeoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports